function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { accounting } from "accounting";
import _ from "lodash";

var CurrencyWidget = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CurrencyWidget, _Component);

  function CurrencyWidget(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      var value = _this.unformat(event.target.value);

      if (!parseInt(value) && !_.startsWith("-")) {
        //if value is 0 the field will reset. and value will set into empty string
        _this.setState({
          value: ""
        });
      } else {
        _this.props.onChange(value);

        _this.setState({
          value: accounting.unformat(event.target.value)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "unformat", function (value) {
      return (accounting.unformat(value) * 100).toFixed(_this.precision);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var unformattedValue = _this.unformat(event.target.value);

      _this.props.onChange(unformattedValue);

      _this.setState({
        value: accounting.formatMoney(event.target.value)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputValueChange", function (event) {
      var isNumberAccepted = new RegExp(/(^[-|\+|0-9][0-9]*)(\.*||\.[0-9]*)$/).test(event.target.value);

      if (isNumberAccepted || _.isEmpty(event.target.value)) {
        _this.setState({
          value: event.target.value
        });
      }
    });

    _this.precision = props.options.precision === undefined ? 2 : props.options.precision;
    accounting.settings = {
      currency: {
        symbol: !props.options.symbol ? "$" : props.options.symbol,
        // default currency symbol is '$'
        format: {
          pos: !props.options.format ? "%s%v" : props.options.format,
          neg: !props.options.format ? "%s(%v)" : props.options.format,
          zero: "%s  -- "
        },
        // controls output: %s = symbol, %v = value/number
        decimal: ".",
        // decimal point separator
        thousand: ",",
        // thousands separator
        precision: _this.precision // decimal places

      },
      number: {
        precision: _this.precision,
        // default precision on numbers is 0
        thousand: ",",
        decimal: "."
      }
    };
    _this.state = _extends({}, props, {
      precision: _this.precision,
      value: accounting.formatMoney(props.value / 100)
    });
    return _this;
  }

  var _proto = CurrencyWidget.prototype;

  _proto.render = function render() {
    var _$get = _.get(this.props, "schema", {}),
        title = _$get.title;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "form-control currency",
      style: {
        textAlign: "right"
      },
      value: this.state.value,
      required: this.state.required,
      onChange: this.handleInputValueChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      disabled: this.state.disabled,
      readOnly: this.state.readonly
    }));
  };

  return CurrencyWidget;
}(Component);

export default CurrencyWidget;